import store from   './store'
import router from './router'
import utils from './utilities'
import * as $route from "vue-router";

var Properties = {


    getErrorMessage(message) {
        // first check is for messages that are of no use to the end user so they come like this from the back end , and we show generic error
        if (message.startsWith('{internal}')) {
            var storeObj = {
                title: 'Σφάλμα!',
                text: 'Παρουσιάστηκε σφάλμα στην εφαρμογή. Παρακαλώ κάντε επανεκκίνηση (refresh) και αν το πρόβλημα επιμείνει επικοινωνήστε με το Γραφείο Αρωγής Χρηστών.',
                color: 'indianRed',
                class: 'white--text indianRed text-center justify-center',
                icon: 'error',
                successStyle: false
            };
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        //then check for code part of the message and replace with greek message
        else {
            var messagePart = message.split(/{(.*)}/); // get the error code as messagePart[1]
            var errorProps = {
                title: 'Σφάλμα!',
                text: '',
                color: 'indianRed',
                class: 'white--text indianRed text-center justify-center',
                icon: 'error',
                successStyle: false
            };

            if (messagePart[1] === "not.authenticated") {
                store.commit('setLoginModal', true);
                if (router.currentRoute.path !== '/') {
                    router.push({path: '/'});
                }
                store.dispatch('resetState');
                utils.removeTokenFromBrowser();
            }else if(messagePart[1] ==="not.authorised"){
                errorProps.text = messagePart[2];
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }else if(messagePart[1] ==="error"){
                errorProps.text = messagePart[2];
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }else if(messagePart[1] ==="pricing.error"){
                errorProps.text = messagePart[2];
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }else if(messagePart[1] ==="internal"){
                errorProps.text = "Παρουσιάστηκε κάποιο σφάλμα στην επικοινωνία με το σύστημα. Πατήστε \"Ανανέωση\" στον browser και αν το πρόβλημα επιμείνει παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }else if(messagePart[1]){
                errorProps.text = messagePart[2];
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }
            else{
                errorProps.text = "Παρουσιάστηκε κάποιο σφάλμα στην επικοινωνία με το σύστημα. Πατήστε \"Ανανέωση\" στον browser και αν το πρόβλημα επιμείνει παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";
                store.commit('setErrorPopup', true);
                store.commit('setErrorPopupProps', errorProps);
            }
        }
    },

    clearHomeInfo(){

    },
};
export default Properties